import { render } from "./summaryboughtreport.vue?vue&type=template&id=c0b38a8e&scoped=true"
import script from "./summaryboughtreport.vue?vue&type=script&lang=js"
export * from "./summaryboughtreport.vue?vue&type=script&lang=js"

import "./summaryboughtreport.vue?vue&type=style&index=0&id=c0b38a8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b38a8e"]])

export default __exports__